import dates from "./dates";

const couponQueryCode = 'k72rmanj56';

const usStates = [
  {"name":"Alabama","abbreviation":"AL"},
  {"name":"Alaska","abbreviation":"AK"},
  {"name":"Arizona","abbreviation":"AZ"},
  {"name":"Arkansas","abbreviation":"AR"},
  {"name":"California","abbreviation":"CA"},
  {"name":"Colorado","abbreviation":"CO"},
  {"name":"Connecticut","abbreviation":"CT"},
  {"name":"Delaware","abbreviation":"DE"},
  {"name":"District of Columbia","abbreviation":"DC"},
  {"name":"Florida","abbreviation":"FL"},
  {"name":"Georgia","abbreviation":"GA"},
  {"name":"Hawaii","abbreviation":"HI"},
  {"name":"Idaho","abbreviation":"ID"},
  {"name":"Illinois","abbreviation":"IL"},
  {"name":"Indiana","abbreviation":"IN"},
  {"name":"Iowa","abbreviation":"IA"},
  {"name":"Kansa","abbreviation":"KS"},
  {"name":"Kentucky","abbreviation":"KY"},
  {"name":"Lousiana","abbreviation":"LA"},
  {"name":"Maine","abbreviation":"ME"},
  {"name":"Maryland","abbreviation":"MD"},
  {"name":"Massachusetts","abbreviation":"MA"},
  {"name":"Michigan","abbreviation":"MI"},
  {"name":"Minnesota","abbreviation":"MN"},
  {"name":"Mississippi","abbreviation":"MS"},
  {"name":"Missouri","abbreviation":"MO"},
  {"name":"Montana","abbreviation":"MT"},
  {"name":"Nebraska","abbreviation":"NE"},
  {"name":"Nevada","abbreviation":"NV"},
  {"name":"New Hampshire","abbreviation":"NH"},
  {"name":"New Jersey","abbreviation":"NJ"},
  {"name":"New Mexico","abbreviation":"NM"},
  {"name":"New York","abbreviation":"NY"},
  {"name":"North Carolina","abbreviation":"NC"},
  {"name":"North Dakota","abbreviation":"ND"},
  {"name":"Ohio","abbreviation":"OH"},
  {"name":"Oklahoma","abbreviation":"OK"},
  {"name":"Oregon","abbreviation":"OR"},
  {"name":"Pennsylvania","abbreviation":"PA"},
  {"name":"Rhode Island","abbreviation":"RI"},
  {"name":"South Carolina","abbreviation":"SC"},
  {"name":"South Dakota","abbreviation":"SD"},
  {"name":"Tennessee","abbreviation":"TN"},
  {"name":"Texas","abbreviation":"TX"},
  {"name":"Utah","abbreviation":"UT"},
  {"name":"Vermont","abbreviation":"VT"},
  {"name":"Virginia","abbreviation":"VA"},
  {"name":"Washington","abbreviation":"WA"},
  {"name":"West Virginia","abbreviation":"WV"},
  {"name":"Wisconsin","abbreviation":"WI"},
  {"name":"Wyoming","abbreviation":"WY"}
];

const StatsTimeFrames = {
  'month-to-date': {
    value: 'month-to-date',
    label: 'Month to date',

    current_start_date: dates.startOfThisMonth(),
    current_end_date: dates.endOfThisMonth(),

    previous_start_date: dates.startOfLastMonth(),
    previous_end_date: dates.endOfLastMonth(),
  },
  'last-30-days': {
    value: 'last-30-days',
    label: 'Last 30 Days',

    current_start_date: dates.startOfLastXDays(30),
    current_end_date: dates.endOfLastXDays(1),

    previous_start_date: dates.startOfLastXDays(60),
    previous_end_date: dates.endOfLastXDays(31),
  },
  'last-90-days': {
    value: 'last-90-days',
    label: 'Last 90 Days',

    current_start_date: dates.startOfLastXDays(90),
    current_end_date: dates.endOfLastXDays(1),

    previous_start_date: dates.startOfLastXDays(180),
    previous_end_date: dates.endOfLastXDays(91),
  },
  'all-time': {
    value: 'all-time',
    label: 'All Time',

    current_start_date: dates.startOfLastXYears(20),
    current_end_date: dates.endOfLastXDays(1),

    previous_start_date: null,
    previous_end_date: null,
  },
}

const timeFrames = [
  {
    value: 'today',
    label: 'Today',
    start: dates.startOfToday(),
    end: dates.endOfToday()
  },
  {
    value: 'yesterday',
    label: 'Yesterday',
    start: dates.startOfYesterday(),
    end: dates.endOfYesterday()
  },
  {
    value: 'this_week',
    label: 'This Week',
    start: dates.startOfThisWeek(),
    end: dates.endOfThisWeek()
  },
  {
    value: 'last_week',
    label: 'Last Week',
    start: dates.startOfLastWeek(),
    end: dates.endOfLastWeek()
  },
  {
    value: 'last_7',
    label: 'Last 7 Days',
    start: dates.startOfLast7Days(),
    end: dates.endOfToday()
  },
  {
    value: 'this_month',
    label: 'This Month',
    start: dates.startOfThisMonth(),
    end: dates.endOfThisMonth()
  },
  {
    value: 'last_month',
    label: 'Last Month',
    start: dates.startOfLastMonth(),
    end: dates.endOfLastMonth()
  },
  {
    value: 'last_30',
    label: 'Last 30 Days',
    start: dates.startOfLast30Days(),
    end: dates.endOfToday()
  },
  {
    value: 'last_60',
    label: 'Last 60 Days',
    start: dates.startOfLastXDays(60),
    end: dates.endOfToday()
  },
  {
    value: 'this_year',
    label: 'This Year',
    start: dates.startOfThisYear(),
    end: dates.endOfThisYear()
  },
  {
    value: 'last_year',
    label: 'Last Year',
    start: dates.startOfLastYear(),
    end: dates.endOfLastYear()
  }
];

const timeframesEmail = [
  {
    value: 'last_24',
    label: 'Last 24 hours',
    start: dates.startOfToday(),
    end: dates.endOfToday()
  },
  {
    value: 'last_7',
    label: 'Last 7 Days',
    start: dates.startOfLast7Days(),
    end: dates.endOfToday()
  },
  {
    value: 'last_30',
    label: 'Last 30 Days',
    start: dates.startOfLast30Days(),
    end: dates.endOfToday()
  },
  {
    value: 'last_365',
    label: 'Last 365 Days',
    start: dates.startOfLast365Days(),
    end: dates.endOfToday()
  },
];

export {
  usStates,
  couponQueryCode,
  StatsTimeFrames,
  timeFrames,
  timeframesEmail,
};
